import { UploadFile } from "./upload-file.model";

export class FacilityContract {
    Id: number;
    ContractDuration: number;
    ContractStartDate: string | Date;
    ContractEndDate: string | Date;
    SignedContract: string;
    SignedContractFile: UploadFile;
}